import * as S from './styles'
import { useChallenge } from './useChallenge'
import { Text } from '@/components'
import { useIsVisibleElement } from '@/hooks'
import { Challenge } from '@/service/api/casePage'

export type ChallengeContainerProps = {
  data: Challenge
  color: string
}
export const ChallengeContainer: React.FC<ChallengeContainerProps> = ({
  data,
  color,
}) => {
  const { fontSizes } = useChallenge()

  const { element, elementVisible } = useIsVisibleElement()
  return (
    <S.ChallengeContainer color={color} elementVisible={elementVisible}>
      <div className="container" ref={element}>
        <Text size={fontSizes.title} className="title" color="darkgray">
          {data?.title}
          <span className="bar" />
        </Text>
        <Text size={fontSizes.description} color="darkgray">
          {data?.description}
        </Text>
      </div>
    </S.ChallengeContainer>
  )
}
